"use client";
import Image from "next/image";
import React from "react";

export function QRIcon({
  size = 16,
  alt = "QR",
  className,
}: {
  size?: number;
  alt?: string;
  className?: string;
}) {
  return (
    <img
      src="/icons/QR.png"
      width={size}
      height={size}
      alt={alt}
      className={className}
    />
  );
}
